import React from 'react';

const CameraOffSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            className="camera-off_svg__cls-1"
            fill="none"
            d="M12 8a5 5 0 0 1 4.28 7.57L19.71 19H21V7H7.71l1.72 1.76A4.9 4.9 0 0 1 12 8z"
        />
        <path
            className="camera-off_svg__cls-1"
            fill="none"
            d="M16 13a4 4 0 0 0-4-4 3.94 3.94 0 0 0-1.84.45l5.39 5.39A3.94 3.94 0 0 0 16 13z"
        />
        <path
            className="camera-off_svg__cls-2"
            fill="#4b4d63"
            d="M3 19.04v-12h1.88l-1-1H2v14h15.88l-1-1H3z"
        />
        <path
            className="camera-off_svg__cls-2"
            d="M12 17a4 4 0 0 1-3.33-6.21L8 10.11A5 5 0 0 0 12 18a4.94 4.94 0 0 0 2.93-1l-.72-.72A4 4 0 0 1 12 17z"
        />
        <path
            className="camera-off_svg__cls-3"
            fillRule="evenodd"
            d="M22 6h-6V4H8v2H6.71L6 5.33V4H5v.29L2.78 2.11l-.7.71L5 5.74l1 1 .3.3 2.32 2.32.71.71L15 15.71l.71.71L18.3 19l1 1 1.85 1.85.37-.38.33-.33L20.71 20H22zM9 5h6v1H9zm6.55 9.84l-5.39-5.35A3.94 3.94 0 0 1 12 9a4 4 0 0 1 4 4 3.94 3.94 0 0 1-.45 1.88zM21 19h-1.29l-3.43-3.43A5 5 0 0 0 12 8a4.9 4.9 0 0 0-2.57.72L7.71 7H21z"
        />
    </svg>
);

CameraOffSvg.displayName = 'CameraOffSvg';
export default CameraOffSvg;
